import React__default from 'react';

var LogoLoader = function (_a) {
    var src = _a.src;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "loading-content-middle-img" }),
        React__default.createElement("div", { className: "loading-c-middle-ins logo" },
            React__default.createElement("img", { src: src, alt: "logo" }))));
};

export { LogoLoader };
